export class SortData {
  constructor(
    public field: string,
    public order: number
  ) {}
}
